/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';
import { registerDestructor } from '@ember/destroyable';
import { CAN_MANAGE_KNOWLEDGE_BASE_CONTENT } from 'embercom/lib/knowledge-hub/constants';

interface Signature {
  Args: {};
}

export default class DrawerEditorBridge extends Component<Signature> {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;
  @service declare permissionsService: $TSFixMe;

  constructor(owner: unknown, args: {}) {
    super(owner, args);

    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'content-readiness:open-editor',
      async (data) => {
        let eventData = data as {
          activeContentId: number;
          activeContentType: string;
        };
        if (!eventData.activeContentId || !eventData.activeContentType) {
          return;
        }
        try {
          await this.permissionsService.checkPermission(CAN_MANAGE_KNOWLEDGE_BASE_CONTENT);
        } catch (e: unknown) {
          // permissionsService displays the error modal
          return;
        }
        this.knowledgeHubDrawerEditorService.openEditDrawer({
          activeContentId: eventData.activeContentId,
          activeContentType: eventData.activeContentType,
        });
      },
    );

    registerDestructor(this, () => {
      unsubscribe();
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentReadiness::DrawerEditorBridge': typeof DrawerEditorBridge;
    'content-readiness/drawer-editor-bridge': typeof DrawerEditorBridge;
  }
}
